import { styled } from 'theme'

export const StyledRentalObjectAssignmentHistoryItemEdit = styled.div`
  background-color: white;
  padding: 1rem 0rem;
  max-width: 700px;
  margin: 0 auto;
`

export const StyledTitle = styled.div`
  padding: 1rem;
  font-size: 18px;
  font-weight: bold;
`
